<div class="page-inner-body portlet light">
  <div class="portlet-body">
    <!-- Skeleton Loader -->
    @if (loading) {
      <div class="skeleton-loader">
        <div class="d-flex justify-content-between align-items-center py-3" style="border-bottom: 1px solid #e9ecef;">
          <div class="skeleton" style="width: 220px; height: 28px;"></div>
          <div class="skeleton" style="width: 140px; height: 36px; border-radius: 6px;"></div>
        </div>
        <div class="skeleton" style="width: 60%; height: 40px; border-radius: 6px; margin: 16px 0;"></div>
        <div class="d-flex py-2" style="border-bottom: 1px solid #e9ecef; gap: 16px;">
          <div class="skeleton" style="width: 30%; height: 18px;"></div>
          <div class="skeleton" style="width: 25%; height: 18px;"></div>
          <div class="skeleton" style="width: 15%; height: 18px;"></div>
          <div class="skeleton" style="width: 15%; height: 18px;"></div>
          <div class="skeleton" style="width: 12%; height: 18px;"></div>
        </div>
        @for (i of [1,2,3,4,5,6,7,8]; track i) {
          <div class="d-flex py-3" style="border-bottom: 1px solid #f1f5f9; gap: 16px;">
            <div class="skeleton" style="width: 30%; height: 16px;"></div>
            <div class="skeleton" style="width: 25%; height: 16px;"></div>
            <div class="skeleton" style="width: 15%; height: 16px;"></div>
            <div class="skeleton" style="width: 15%; height: 16px;"></div>
            <div class="skeleton" style="width: 12%; height: 16px;"></div>
          </div>
        }
      </div>
    }

    @if (!loading) {
      <div class="row text-align">
        <div class="col-md-12">
          <p-toolbar>
            <div class="p-toolbar-group-start fs-4">{{ 'emailSettings.emailTemplates' | transloco }}@if (allemailEvents.length > 0) {
              ({{
              allemailEvents.length }})
            }</div>
            <div class="p-toolbar-group-end">
              <button type="button" pButton icon="fa fa-add" [label]="'emailSettings.addTemplate' | transloco"
                class="p-button-secondary  p-button-outlined" (click)="openDialog()">
              </button>
            </div>
          </p-toolbar>
          <form class="form mt-3" #emailSettingsForm="ngForm">
            @if (allemailEvents.length > 0) {
              <div class="row mt-2">
                <div class="col-12">
                  <p-table #dt [value]="allemailEvents" [paginator]="false"
                    [globalFilterFields]="['Subject','EventTypeViewModel.Name','CreatedDate','ModifiedDate']">
                    <ng-template pTemplate="caption">
                      <div class="p-inputgroup d-flex align-items-center">
                        <i class="pi pi-search"></i>
                        <input type="text"
                          class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                          (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                          [placeholder]="'emailSettings.searchEmailTemplates' | transloco" />
                        </div>
                      </ng-template>
                      <ng-template pTemplate="header">
                        <tr>
                          <th pSortableColumn="EventName" style="width: 40%;">{{ 'emailSettings.templateName' | transloco }} <p-sortIcon
                          field="EventName"></p-sortIcon></th>
                          <th pSortableColumn="EventName" style="width: 30%;">{{ 'emailSettings.subject' | transloco }} <p-sortIcon
                          field="EventName"></p-sortIcon></th>
                          <!-- <th pSortableColumn="EventName" style="width: 40%;">Content <p-sortIcon field="EventName"></p-sortIcon></th> -->
                          <th pSortableColumn="CreatedDate" style="width: 15%;">{{ 'emailSettings.createdDate' | transloco }} <p-sortIcon
                          field="CreatedDate"></p-sortIcon></th>
                          <th pSortableColumn="ModifiedDate" style="width: 15%;">{{ 'emailSettings.modifiedDate' | transloco }} <p-sortIcon
                          field="ModifiedDate"></p-sortIcon></th>
                          <th class="text-end" style="width: 20%;">{{ 'emailSettings.actions' | transloco }}</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-event>
                        <tr>
                          <td class="p-3" style="max-width: 300px; word-wrap: break-word;">
                            <div class="fw-bold text-secondary cursor-pointer text-uppeercase"
                              (click)="showEditDialog(event)" [pTooltip]="'emailSettings.edit' | transloco: { name: event.EventName }" tooltipPosition="top">
                              {{ event.EventTypeViewModel.Name }}
                              <!-- <ng-container *ngIf="event.EventTypeViewModel?.IsPredefined"> -->
                              @if (event.EventTypeViewModel?.IsPredefined) {
                                <span class="badge"
                                  [ngStyle]="{'background-color': '#178d9b', 'color': 'white'}">
                                  {{ 'emailSettings.system' | transloco }}
                                </span>
                              }
                            <!-- </ng-container> -->
                          </div>
                          <div class="small text-muted">{{ event.EventTypeViewModel.Description }}</div>
                        </td>
                        <td class="p-2">{{ event.Subject }}</td>
                        <!-- <td class="p-2">{{ event.HtmlText }}</td> -->
                        <td class="p-2">{{ event.CreatedDate | date: 'dd/MM/yyyy, h:mm a' }}</td>
                        <td class="p-2">{{ event.ModifiedDate | date: 'dd/MM/yyyy, h:mm a' }}</td>
                        <td class="d-flex justify-content-center text-end p-2">
                          <button type="button" pButton icon="fa fa-edit ms-1" class="p-button-sm p-button-outlined mt-3"
                            icon="pi pi-pencil" (click)="showEditDialog(event)" [pTooltip]="'emailSettings.edit' | transloco: { name: event.EventName }"
                            tooltipPosition="left">
                          </button>
                          @if (!event.EventTypeViewModel?.IsPredefined) {
                            <button pButton (click)="onDeleteEmailTemplate(event.Id)"
                              class="p-button-danger p-button-sm ms-2 p-button-outlined mt-3" icon="pi pi-trash"
                            size="small"></button>
                          }
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            }
          </form>
        </div>
      </div>
    }
  </div>
</div>

@if (displayDialog) {
  <email-setting-template-dailog [displayDialog]="displayDialog" [emailEvents]="emailEvents"
    [selectedEmailTemplate]="selectedEmailTemplate" [selectedEmailParameter]="selectedEmailParameter"
    [emailParameters]="emailParameters" [isEditMode]="isEditMode" (fetchEmailTemplate)="fetchAllEvents()"
    (onCloseEmailTemplateDailog)="onCloseEmailTemplateDialog($event)">
  </email-setting-template-dailog>
}